import { Card, Collapse, Drawer } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import './styles.css';


const items = [
  {
    key: 1,
    label: <div className='preguntas-collapse-panel-header'>¿Cómo puedo comprar un pase médico?</div>,
    children: <div className='preguntas-collapse-panel-content'>Para comprar un pase médico, debes seguir los siguientes pasos: <br></br>1. Ingresa a la página web.<br></br>2. Llena el formulario con tus datos personales.<br></br>3. Realiza el pago del pase médico.<br></br>4. Recibe tu pase médico en tu correo electrónico.</div>
  },
  {
    key: 2,
    label: <div className='preguntas-collapse-panel-header'>¿Cuánto tiempo tarda en llegar mi pase médico?'</div>,
    children: <div className='preguntas-collapse-panel-content'>El tiempo de entrega del pase médico depende de la velocidad de procesamiento, normalmente en el momento de su compra, recibirá un correo electrónico con su pase médico. El tiempo estimado de entrega es de 24 horas hábiles después de haber realizado el pago. Si no recibes tu pase médico dentro de este tiempo, por favor comunícate con nuestro equipo de soporte técnico.</div>
  },
  {
    key: 3,
    label: <div className='preguntas-collapse-panel-header'>¿Qué debo hacer si no recibo mi pase médico?</div>,
    children: <div className='preguntas-collapse-panel-content'>Si no recibes tu pase médico en el tiempo estipulado, por favor comunícate con nuestro equipo de soporte técnico al teléfono 899 921 6700 o al correo electrónico info@hospitalsantander.com.mx</div>,
  }
];

const FrequentlyQuestionsComponent = ({ open, onClose }) => {
  return (
    <Drawer
      open={open}
      size='large'
      style={{ backgroundColor: '#b3b3b385', borderColor: 'transparent' }} 
      title={<div style={{ backgroundColor: "#9b1c31", borderRadius: "12px" }}>
        <h2 style={{ color: 'white', fontSize: 'calc(.7vw + 1vh + 0.5vmin)', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: 'auto', padding: '8px 0px' }}>PREGUNTAS FRECUENTES</h2></div>}
      closeIcon={<CloseOutlined onClick={onClose} style={{ color: 'white', fontSize: "200%" }}

      />}
    >
      <Card size='small' style={{ borderColor: '#f0f0f0', backgroundColor: '#f0f0f0', height: '100%', position: 'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
          <Collapse items={items} bordered={false} style={{ flex: 1, overflow: 'auto', backgroundColor: 'transparent', borderColor: 'transparent' }}
            expandIcon={({ isActive }) => <CaretRightOutlined style={{ color: "black" }} rotate={isActive ? 90 : 0} />}
          />
        </div>
      </Card>
    </Drawer>
  );
};

export default FrequentlyQuestionsComponent;
